import AjaxPromises from './AjaxPromises.js';
import NotificationActions from '../actions/NotificationActions';
import UserStore from '../stores/UserStore';

export default {
    post: async (url, data, failureMessage, successMessage, booleanData) => {
        try {
            const formData = UserStore.getApiData(data);
            let resp = await AjaxPromises.POST(url, formData);

            if (!resp.Result) {
                throw resp;
            }
            if (successMessage) {
                NotificationActions.success(successMessage);
            }

            return booleanData ? resp.Data : resp.Data || true;
        } catch (ex) {
            console.error(ex);
            var message;

            if (ex.Message) {
                message = ex.Message;
            }

            var error = message || failureMessage;
            NotificationActions.error(error);
            return false;
        }
    },
};



// WEBPACK FOOTER //
// ./ui_src/app/utils/HttpClient.js